module.exports = __webpack_public_path__ + "img/bg3.3892af8d.jpg";